export default {
  init() {
    // JavaScript to be fired on all pages
    $('.filters a').on('click', function(e) {
      if(!$('.resources').hasClass('showing-one')){
        $('.resources').addClass('showing-one')
      }

      // removed for new filtering //let postType = $(this).attr('data-filter');
      // Stop link from actually doing anything
      // removed for new filtering //e.preventDefault();
      e; // added cause stylelint is stupid and blocks this function if 'e' isn't used

      // Set other buttons inactive
      // removed for new filtering //$('.filters a').each(function() {
      // removed for new filtering //  $(this).addClass('inactive');
      // removed for new filtering //  if(postType == $(this).attr('data-filter')) {
      // removed for new filtering //    $(this).removeClass('inactive');
      // removed for new filtering //  }
      // removed for new filtering //});

      // Hide other posts
      // removed for new filtering //$('.resource').each(function() {
      // removed for new filtering //  if($(this).attr('data-type') == postType) {
      // removed for new filtering //    $(this).show();
      // removed for new filtering //  } else {
      // removed for new filtering //    $(this).hide();
      // removed for new filtering //  }
      // removed for new filtering //})
    });
    
    //  lightbox - *any* lightbox - close any lightbox when clicking close-popup
    $('.sf-lightbox').on('click','.close-popup',function(){
      var _lightbox = $(this).closest('.sf-lightbox.active');
      _lightbox.removeClass('active');
      if($('.sf-lightbox.video-lightbox').length > 0) {
        $('.sf-lightbox.video-lightbox').find('iframe').attr('src','');
      }
      $('body').css('overflow','auto');
    })

    //  resources videos
    $('.video-activate-sf-lightbox').on('click',function(e){
      e.preventDefault();
      var _embed_video_link = $(this).attr('data-link');
      var _video_lightbox = $('.sf-lightbox.video-lightbox');
      _video_lightbox.find('iframe').attr('src',_embed_video_link);
      
      if(!_video_lightbox.hasClass('active')) {_video_lightbox.addClass('active'); $('body').css('overflow','hidden');}
      
    })

    
    if (!window.$) { $ = jQuery; }
    
    //  ███████████████████████████████████████████████████████████████████████████████
    //  █████████████ Form Labels                                      ████████████████
    //  clicking an input makes label smaller above
    var _load_gform_dynamic_label_scripts = true;

    if (_load_gform_dynamic_label_scripts) {
      // GFORM dynamic labels
      if($('.gfield input:not([type=checkbox])').length) {
        $('.gfield input:not([type=checkbox])').map(function (i, val) {
          if ($(val).val().length > 0) {
            $(this).closest('.gfield:not(._focused)').addClass('_focused');
          }
        })
      }

      (function (dynamic_label, $, undefined) {
        dynamic_label.setFocusedFields = function() {
          $('.gfield input:not([type=checkbox]), .gfield textarea').map((i, el) => {
            if($(el).val().length > 0) {
              $(el).closest('.gfield')[0].classList.add('_focused');
            }
          })
        }
      }(window.dynamic_label = window.dynamic_label || {}, jQuery));

      // on form render, setfocused fields
      jQuery(document).on('gform_post_render', function(event, form_id, current_page){
        dynamic_label.setFocusedFields();
      });
 
      //listeners on section
      $('body').on('focusin', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        $(this).closest('.gfield').addClass('_focused');
      });

      $('body').on('focusout', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        setTimeout(function (that) {
          if ($(that).val().length == 0) {
            $(that).closest('.gfield').removeClass('_focused');
          }
        }, 10, this)
      });

      // listeners on lightbox form
      $('.lightbox-form-parent').on('focusin', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        $(this).closest('.gfield').addClass('_focused');
      });

      $('.lightbox-form-parent').on('focusout', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        setTimeout(function (that) {
          if ($(that).val().length == 0) {
            $(that).closest('.gfield').removeClass('_focused');
          }
        }, 10, this)
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js